import {getAPIGatewayPostRequest, getNodeId} from "../../util/Util";
import {
    ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT,
    ANDON_COLORS,
    DEFAULT_ANDON_COLOR_HEX,
    LIGHT_COMMAND_ON,
    LIGHT_COMMAND_OFF,
    PROMISE_FULFILLED,
    HTTP_STATUS,
    ANDON_PROCESS_NAME,
    METRIC_PUBLISH_LIGHT_COMMAND,
    DEFAULT_ANDON_BATCH_SIZE,
    ERROR_METRIC_SUFFIX,
    LED_CONTROLLER_ASSET_TYPE,
    ON_STATE,
    OFF_STATE,
    CART_RESOURCE_TYPE
} from "../../util/Constants";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {publishCount, publishTime} from "../../util/MetricUtility";

function getColorHex(colorValue) {
    const found = ANDON_COLORS.find(c => c.value === colorValue);
    return found ? found.hex : DEFAULT_ANDON_COLOR_HEX;
}

async function publishLightCommand(cartId, command, color, durationMinutes) {
    const startTime = Date.now();
    const commandParams = {
        locationType: CART_RESOURCE_TYPE,
        state: command === LIGHT_COMMAND_ON ? ON_STATE : OFF_STATE,
        scannable: cartId
    };
    if (command === LIGHT_COMMAND_ON) {
        commandParams.color = color;
        commandParams.durationMs = String(durationMinutes * 60 * 1000);
    }
    const request = {
        nodeId: getNodeId(),
        assetType: LED_CONTROLLER_ASSET_TYPE,
        commandParams
    };
    const args = getAPIGatewayPostRequest(request, ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT);
    try {
        const response = await getAPIGatewayDataFromParent(args);
        publishTime(ANDON_PROCESS_NAME, METRIC_PUBLISH_LIGHT_COMMAND, startTime);
        return response;
    } catch (e) {
        publishCount(ANDON_PROCESS_NAME, METRIC_PUBLISH_LIGHT_COMMAND + ERROR_METRIC_SUFFIX);
        throw e;
    }
}

function aggregateResults(results) {
    const succeeded = results.filter(r => r.status === PROMISE_FULFILLED && r.value && r.value.status === HTTP_STATUS.OK).length;
    return {succeeded, failed: results.length - succeeded, total: results.length};
}

async function sendCommandInBatches(cartIds, commandFn, batchSize = DEFAULT_ANDON_BATCH_SIZE) {
    const allResults = [];
    for (let i = 0; i < cartIds.length; i += batchSize) {
        const batch = cartIds.slice(i, i + batchSize);
        const results = await Promise.allSettled(batch.map(commandFn));
        allResults.push(...results);
    }
    return aggregateResults(allResults);
}

async function sendOnCommand(cartIds, color, durationMinutes) {
    if (!cartIds || !cartIds.length) return {succeeded: 0, failed: 0, total: 0};
    return sendCommandInBatches(cartIds, id => publishLightCommand(id, LIGHT_COMMAND_ON, color, durationMinutes));
}

async function sendOffCommand(cartIds) {
    if (!cartIds || !cartIds.length) return {succeeded: 0, failed: 0, total: 0};
    return sendCommandInBatches(cartIds, id => publishLightCommand(id, LIGHT_COMMAND_OFF));
}

export {
    getColorHex,
    sendOnCommand,
    sendOffCommand
};



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontrollerstag/SBLCommandUtils.js